import { UncontrolledTooltip } from "reactstrap"

const ButtonTooltip = ({
  type = "view", // "add" | "edit" | "view" | "delete" | "refresh" | "download" | "pdf"
  btnId = "1",
  btnName,
  loading = false,
  is_label = false,
  ...props
}) => {
  const btnColors = {
    add: "success",
    edit: "info",
    view: "primary",
    delete: "danger",
    refresh: "light",
    download: "secondary",
    pdf: "dark",
  }

  const icons = {
    add: "mdi mdi-plus",
    edit: "mdi mdi-pencil-outline",
    view: "mdi mdi-eye-outline",
    delete: "mdi mdi-delete-outline",
    refresh: `mdi mdi-refresh ${loading ? "mdi-spin" : ""}`,
    download: loading ? "mdi mdi-progress-download" : "mdi mdi-download",
    pdf: "mdi mdi-file-pdf-box", // 👈 PDF icon
  }

  const labels = {
    add: "Add",
    edit: "Edit",
    view: "View",
    delete: "Delete",
    refresh: "Refresh",
    download: loading ? "Downloading..." : "Download",
    pdf: "Download PDF", // 👈 label for tooltip
  }

  const color = btnColors[type] || "secondary"
  const icon = icons[type] || "mdi mdi-help-circle-outline"
  const label = btnName || labels[type] || "Action"

  // handle 'btnId' slugification to ensure valid HTML id (no spaces, special chars)
  const slugifiedBtnId = btnId.toString().toLowerCase().replace(/\s+/g, "-")
  return (
    <button
      type="button"
      className={`btn btn-sm btn-soft-${color}`}
      id={`tooltip-${slugifiedBtnId}`}
      disabled={loading}
      {...props}
    >
      <i className={icon} />
      {is_label ? (
        label
      ) : (
        <UncontrolledTooltip placement="top" target={`tooltip-${slugifiedBtnId}`}>
          {label}
        </UncontrolledTooltip>
      )}
    </button>
  )
}

export default ButtonTooltip
